export default __webpack_public_path__ + "pets.31af98eaa12643e1b5d07749b75bc866.png";